import { render, staticRenderFns } from "./building-selector.vue?vue&type=template&id=5b0865b8&"
import script from "./building-selector.vue?vue&type=script&lang=js&"
export * from "./building-selector.vue?vue&type=script&lang=js&"
import style0 from "./building-selector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports